export const getUiPictureTemplate = (options = {}) => {
  const {
    className = '',
    mediaClassName = '',
    imagesData = {},
    width = null,
    height = null,
    isCover = true,
    isLazy = true,
    decoding = 'async',
    alt = ''
  } = options

  const images = [
    {
      mediaWidth: 1280,
      image: imagesData?.xl
    },
    {
      mediaWidth: 1024,
      image: imagesData?.lg
    },
    {
      mediaWidth: 768,
      image: imagesData?.md
    }
  ].filter(set => set.image)

  return (
    `<picture class="ui-picture ${!isCover ? 'ui-picture--contain' : ''} ${className}">
      ${images.map(({ image, mediaWidth }) => (
        `
          ${image.avif
            ? `<source
                srcset="${image.avif['1x']} ${image.avif['2x'] ? `1x, ${image.avif['2x']} 2x` : ''}"
                media="(min-width: ${mediaWidth}px)"
                type="image/avif"
              >`
            : ''
          }

          ${image.webp
            ? `<source
                srcset="${image.webp['1x']} ${image.webp['2x'] ? `1x, ${image.webp['2x']} 2x` : ''}"
                media="(min-width: ${mediaWidth}px)"
                type="image/webp"
              >`
            : ''
          }

          ${image.img
            ? `<source
                srcset="${image.img['1x']} ${image.img['2x'] ? `1x, ${image.img['2x']} 2x` : ''}"
                media="(min-width: ${mediaWidth}px)"
              >`
            : ''
          }
        `
      )).join('')}

      ${imagesData?.sm?.img?.['1x']
        ? `${imagesData.sm.avif?.['1x']
            ? `<source
                srcset="${imagesData.sm.avif['1x']} ${imagesData.sm.avif['2x'] ? `1x, ${imagesData.sm.avif['2x']} 2x` : ''}"
                type="image/avif"
              >`
            : ''
          }

          ${imagesData.sm.webp?.['1x']
            ? `<source
                srcset="${imagesData.sm.webp['1x']} ${imagesData.sm.webp['2x'] ? `1x, ${imagesData.sm.webp['2x']} 2x` : ''}"
                type="image/webp"
              >`
            : ''
          }

          <img
            class="ui-picture__img ui-picture__img--${isCover ? 'cover' : 'contain'} ${mediaClassName}"
            src="${imagesData.sm.img['1x']}"
            ${imagesData.sm.img['2x'] ? `srcset="${imagesData.sm.img['2x']} 2x"` : ''}
            ${width ? `width="${width}"` : ''}
            ${height ? `height="${height}"` : ''}
            loading="${isLazy ? 'lazy' : 'eager'}"
            decoding="${decoding}"
            alt="${alt}"
          >`
        : ''
      }
    </picture>`
  )
}
